import { useEffect, useRef, useState } from 'react'

/**
 * 파일 메뉴 — 새로 만들기 / 열기 / 저장(▸ 서브: 화성분석리포트 · 악보).
 * 바깥 클릭·Esc로 닫힘.
 */
export default function FileMenu({
  open = false,
  onOpenChange,
  onNew,
  onOpen,
  onSaveReport,
  onSaveScore,
  canSaveReport = false,
  canSaveScore = false,
}) {
  const rootRef = useRef(null)
  const [saveOpen, setSaveOpen] = useState(false)

  useEffect(() => {
    if (!open) {
      setSaveOpen(false)
      return undefined
    }
    const onDoc = (e) => {
      if (!rootRef.current?.contains(e.target)) onOpenChange?.(false)
    }
    const onKey = (e) => {
      if (e.key === 'Escape') {
        if (saveOpen) setSaveOpen(false)
        else onOpenChange?.(false)
      }
    }
    document.addEventListener('mousedown', onDoc)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onDoc)
      document.removeEventListener('keydown', onKey)
    }
  }, [open, onOpenChange, saveOpen])

  if (!open) return null

  const closeAll = () => {
    setSaveOpen(false)
    onOpenChange?.(false)
  }

  return (
    <div
      className={`file-menu file-menu--panel${typeof window !== 'undefined' && window.kordAI?.isElectron ? ' is-electron' : ''}`}
      ref={rootRef}
    >
      <div className="file-menu-dropdown" role="menu" aria-label="파일">
        <button
          type="button"
          className="file-menu-item"
          role="menuitem"
          onClick={() => {
            closeAll()
            onNew?.()
          }}
        >
          새로 만들기
          <span className="file-menu-item-hint">Ctrl+N</span>
        </button>

        <button
          type="button"
          className="file-menu-item"
          role="menuitem"
          onClick={() => {
            closeAll()
            onOpen?.()
          }}
        >
          열기
        </button>

        <div className="file-menu-sep" role="separator" />

        <div className={`file-menu-item-row${saveOpen ? ' is-open' : ''}`}>
          <button
            type="button"
            className="file-menu-item file-menu-item--grow"
            role="menuitem"
            aria-haspopup="menu"
            aria-expanded={saveOpen}
            disabled={!canSaveReport && !canSaveScore}
            onClick={() => setSaveOpen((v) => !v)}
          >
            저장
          </button>
          <button
            type="button"
            className={`file-menu-caret${saveOpen ? ' is-open' : ''}`}
            aria-label="저장 하위 메뉴"
            aria-expanded={saveOpen}
            disabled={!canSaveReport && !canSaveScore}
            onClick={() => setSaveOpen((v) => !v)}
          >
            <svg viewBox="0 0 10 10" width="8" height="8" aria-hidden="true">
              <path d="M3 1.5l4.5 3.5L3 8.5z" fill="currentColor" />
            </svg>
          </button>

          {saveOpen && (
            <div className="file-menu-submenu" role="menu" aria-label="저장">
              <button
                type="button"
                className="file-menu-item"
                role="menuitem"
                disabled={!canSaveReport}
                onClick={() => {
                  closeAll()
                  onSaveReport?.()
                }}
              >
                화성분석리포트
                <span className="file-menu-item-hint">JSON</span>
              </button>
              <button
                type="button"
                className="file-menu-item"
                role="menuitem"
                disabled={!canSaveScore}
                onClick={() => {
                  closeAll()
                  onSaveScore?.()
                }}
              >
                악보
                <span className="file-menu-item-hint">MusicXML</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
